import { Component, type ReactNode } from 'react';

/** Last-resort catch so a render error shows a message, not a blank page. */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) {
    return { error };
  }
  componentDidCatch(error: Error) {
    console.error(error);
  }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div role="alert" className="mx-auto max-w-md p-6 text-center">
        <h1 className="mb-2 text-xl font-bold">Something went wrong</h1>
        <p className="mb-4 text-mid">Please reload the page. If it keeps happening, let us know.</p>
        <button className="rounded-md bg-brand px-4 py-2 font-semibold text-on-brand" onClick={() => window.location.reload()}>
          Reload
        </button>
      </div>
    );
  }
}
